export interface MetricData {
    dimensionValues: Record<string, string>
    measureValues: Record<string, number>
}

// An ungrouped metric request returns a single entry holding the total count.
export function metricTotal(data: MetricData[]) {
    return data.at(0)?.measureValues.count ?? 0
}
